// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConfirmationModal_modal__3WPvQ","modalRoot":"ConfirmationModal_modalRoot__142VC","spinner":"ConfirmationModal_spinner__29b5w"};